import CartIcon from "icons/gwc.svg"
import { CartContext, SiteContext } from "libs/contexts"
import Link from "next/link"
import { memo, useContext } from "react"
import { Badge } from "react-vant"
import { cls } from "reactutils"

type CartIconButtonProps = {
  className?: string
  showTitle?: boolean
}

export default memo(function CartIconButton({
  className,
  showTitle = true,
}: CartIconButtonProps) {
  const { quantity } = useContext(CartContext)
  const siteConfig = useContext(SiteContext)

  return (
    <>
      <Link href="/pages/cart">
        <a>
          <div className={cls("cartBtn", className)}>
            <Badge
              content={quantity}
              max={99}
              color={siteConfig?.global?.platformMainColor}
              offset={["-5px", "-5px"]}
              showZero={false}
            >
              <CartIcon width="23" height="20" />
            </Badge>
          </div>
          {showTitle && <span>购物车</span>}
        </a>
      </Link>
      <style jsx>{`
        .cartBtn {
          cursor: pointer;
        }
      `}</style>
    </>
  )
})
